import { createSlice } from "@reduxjs/toolkit";

const adminCompanySlice = createSlice({
    name: "adminCompany",
    initialState: {
        isLoading: false,
        companyInfo: [],
        dropdownEmployeeList: [],
        companyList: [],
        userAdminList: []
    },
    reducers: {
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
        setCompanyInfo(state, action) {
            state.companyInfo = action.payload;
        },
        setDropdownEmployeeList(state, action) {
            state.dropdownEmployeeList = action.payload;
        },
        setCompanyList(state, action) {
            state.companyList = action.payload;
        },
        setUserAdminList(state, action) {
            state.userAdminList = action.payload;
        },
    }
});

export const {
    setIsLoading,
    setCompanyInfo,
    setDropdownEmployeeList,
    setCompanyList,
    setUserAdminList
} = adminCompanySlice.actions;

export default adminCompanySlice.reducer;